import React from 'react';
import { ImagePreviewGroup, Image } from '@routific/hive';
import { Col, Row } from 'antd';
import { OrderEventLogDtoModelType } from '../../../../store/mst/models';
import { IMAGE_COLUMN_SPAN } from './Photos';

interface Props {
  log: OrderEventLogDtoModelType | undefined
}

const Signature: React.FC<Props> = ({ log }) => (log?.signature ? (
  <ImagePreviewGroup>
    <Row>
      <Col span={2 * IMAGE_COLUMN_SPAN}>
        <Image
          src={`data:image/png;base64,${log?.signature.base64Png}`}
          roundedCorners
          preview={{
            src: `data:image/png;base64,${log?.signature.base64Png}`,
          }}
        />
      </Col>
    </Row>
  </ImagePreviewGroup>

) : <></>);

export default Signature;
